import type { Capabilities } from "@/core/capability/detect.ts";
import type { DownloadProgress } from "@/core/storage/moduleCache.ts";

export type FeatureId =
  | "imageops"
  | "audiodsp"
  | "audiodsp"
  | "ffmpeg-core"
  | "ffmpeg-core-mt"
  | "whisper-tiny"
  | "whisper-base"
  | "avif";

export type PackState =
  | { readonly status: "unsupported"; readonly reason: string }
  | { readonly status: "available" }
  | { readonly status: "downloading"; readonly progress: DownloadProgress }
  | { readonly status: "ready" }
  | { readonly status: "failed"; readonly error: string };

export type LoadContext = {
  readonly signal: AbortSignal;
  readonly report: (progress: DownloadProgress) => void;
};

export type FeaturePack<T> = {
  readonly id: FeatureId;
  readonly label: string;
  readonly description: string;
  /** Shown before the download starts, so the size is never a surprise. */
  readonly sizeBytes: number;
  /** The cached asset. Lets the UI tell "already downloaded" from "loaded right now". */
  readonly assetUrl: string;
  readonly requires: readonly FeatureId[];
  readonly unavailableReason: (capabilities: Capabilities) => string | null;
  readonly load: (context: LoadContext) => Promise<T>;
};

export type AnyFeaturePack = FeaturePack<unknown>;

export class FeatureUnsupportedError extends Error {
  constructor(
    readonly featureId: FeatureId,
    reason: string,
  ) {
    super(reason);
    this.name = "FeatureUnsupportedError";
  }
}

export class FeatureMissingError extends Error {
  constructor(readonly featureId: FeatureId) {
    super(`未登録のモジュールです: ${featureId}`);
    this.name = "FeatureMissingError";
  }
}
